export var ConsentKey = /*#__PURE__*/function (ConsentKey) {
  ConsentKey["MARKETING"] = "MARKETING";
  ConsentKey["SCIENCE"] = "SCIENCE";
  ConsentKey["HEALTHKIT"] = "HEALTHKIT";
  ConsentKey["APP"] = "APP";
  ConsentKey["MARKETING_SOCIAL"] = "MARKETING_SOCIAL";
  ConsentKey["ANONYMOUS_TMP_WORLD_LINK"] = "ANONYMOUS_TMP_WORLD_LINK";
  return ConsentKey;
}(ConsentKey || {});
export var ConsentTermsItemToggleKey = /*#__PURE__*/function (ConsentTermsItemToggleKey) {
  ConsentTermsItemToggleKey["marketing"] = "marketing";
  ConsentTermsItemToggleKey["socialMarketing"] = "socialMarketing";
  return ConsentTermsItemToggleKey;
}(ConsentTermsItemToggleKey || {});